import React from "react"
import PropTypes from "prop-types"
import BtnSecondary from '../form_sections/BtnSecondary'
import BtnPrimary from '../form_sections/BtnPrimary'
import StandardButton from '../app_components/StandardButton'
import StandardModal from '../app_components/StandardModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment, faComments } from '@fortawesome/free-regular-svg-icons'
import { faArrowDown, faArrowUp, faPlus, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons'
import Search from '../form_sections/Search'

class LanguageSettings extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      languages: [],
      openLanguageChoices: false,
      languageChoices: [],
      newLanguage: [],
      languageLevelOpen: false,
      levels: [5, 4, 3, 2, 1],
      needsLearningLanguage: false,
      needsNativeLanguage: false,
      errorMessage: "",
      searchLanguageValue: ""
    }

    this.renderNativeLanguages = this.renderNativeLanguages.bind(this)
    this.renderLearningLanguages = this.renderLearningLanguages.bind(this)
    this.renderLanguageSection = this.renderLanguageSection.bind(this)
    this.languageChoices = this.languageChoices.bind(this)
    this.selectALanguage = this.selectALanguage.bind(this)
    this.selectNewLanguage = this.selectNewLanguage.bind(this)
    this.closeLanguageChoices = this.closeLanguageChoices.bind(this)
    this.nativeLevelOptions = this.nativeLevelOptions.bind(this)
    this.learningLevelOptions = this.learningLevelOptions.bind(this)
    this.selectLevel = this.selectLevel.bind(this)
    this.editLanguage = this.editLanguage.bind(this)
    this.updateLanguagesUser = this.updateLanguagesUser.bind(this)
    this.createLanguagesUser = this.createLanguagesUser.bind(this)
    this.updateUserLanguages = this.updateUserLanguages.bind(this)
    this.checkLanguages = this.checkLanguages.bind(this)
    this.languageBackgroundColor = this.languageBackgroundColor.bind(this)
    this.languageLevelText = this.languageLevelText.bind(this)
    this.nextButton = this.nextButton.bind(this)
    this.renderLanguageSuggestions = this.renderLanguageSuggestions.bind(this)
    this.languageChoice = this.languageChoice.bind(this)
    this.languageIsIncluded = this.languageIsIncluded.bind(this)
  }

  componentWillMount() {
    $.ajax({
      url: `../ajaxGetLanguages`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          languages: JSON.parse(data.data.languages),
          languageChoices: data.data.allLanguages
        }, () => this.checkLanguages())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentDidMount() {
    this.checkLanguages()
  }

  languageIsIncluded(language) {
    return this.state.languages.find(lang => lang.language_id === language.id) != undefined
  }

  renderLanguageSuggestions() {
    if(this.state.searchLanguageValue === "") {
      const languages = this.state.languageChoices.filter(language => {
        return language.primary === true && !this.languageIsIncluded(language)
      })
      return languages.slice(0, 6).map((language, i) => {
        return(this.languageChoice(language, i))
      })
    } else {
      let searchLanguageValue = this.state.searchLanguageValue.toLowerCase()
      const languages = this.state.languageChoices.filter(language => {
        return (language.language.toLowerCase().includes(searchLanguageValue) || (language.native != null && language.native.toLowerCase().includes(searchLanguageValue)))
      })
      return languages.slice(0, 6).map((language, i) => {
        return(this.languageChoice(language, i))
      })
    }
  }

  renderLanguageSection(language, index) {
    return(
      <div
        key={index}
        style={{
          display: 'flex', alignItems: 'center', marginTop: 12,
        }}>
        <div
          onClick={() => this.editLanguage(language.language)}
          style={{
            borderRadius: 30,
            backgroundColor: this.languageBackgroundColor(language.level),
            padding: 14,
            cursor: 'pointer',
            width: '95%'}}>
          <h3
            style={{
              color: 'white', fontSize: 18, paddingLeft: 12, textAlign: 'left'
            }}>{this.languageLevelText(language.level)} {language.language.native}</h3>
        </div>
        <FontAwesomeIcon
          onClick={() => this.deleteLanguagesUser(language.id)}
          icon={faXmark}
          className={"red"}
          style={{fontSize: 22, marginLeft: 12, cursor: 'pointer'}}
        />
      </div>
    )
  }

  renderNativeLanguages() {
    return this.state.languages.filter(language => language.level === 5).map((language, index) => {
      return this.renderLanguageSection(language, index)
    })
  }

  renderLearningLanguages() {
    return this.state.languages.filter(language => language.level< 5).map((language, index) => {
      return this.renderLanguageSection(language, index)
    })
  }

  checkLanguages() {
    this.setState({
      needsNativeLanguage: this.state.languages.filter(language => language.level === 5).length < 1,
      needsLearningLanguage: this.state.languages.filter(language => language.level < 5).length < 1
    })
  }



  selectNewLanguage(language) {
    this.setState({
      newLanguage: language,
      languageLevelOpen: true,
      openLanguageChoices: false,
    })
  }

  languageChoice(language, i) {
    const languageIsIncluded = this.languageIsIncluded(language)
    return(
      <div key={i} className={languageIsIncluded ? "selectedItem" : "selectItem"} onClick={() => this.selectNewLanguage(language)}>
        <h5  className={languageIsIncluded ? 'white' : "lightBlue"}>{language.native}</h5>
        <FontAwesomeIcon
          icon={languageIsIncluded ? faCheck : faPlus}
          className={languageIsIncluded ? 'white' : "lightBlue"}
          style={{fontSize: 14, marginLeft:10}}
        />
      </div>
    )
  }

  selectALanguage() {
    return this.state.languageChoices.map((language, i) => {
      return this.languageChoice(language, i)
    })
  }

  editLanguage(language) {
    this.setState({
      newLanguage: language,
      languageLevelOpen: true
    })
  }

  closeLanguageChoices() {
    this.setState({
      openLanguageChoices: false,
      newLanguage: {},
      languageLevelOpen: false
    })
  }

  languageChoices() {
    return(
      <StandardModal onClose={() => this.closeLanguageChoices()}>
        <div className="selectItemContainer" style={{marginTop: 20}}>
            {this.selectALanguage()}
        </div>
      </StandardModal>
    )
  }

  createLanguagesUser(language_id, level) {
    let data = {
      level: level,
      language_id: language_id
    }
    this.setState({
      languageLevelOpen: false
    })

    $.ajax({
      url: `../ajaxCreateLanguagesUser`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.updateUserLanguages(JSON.parse(data.data.languages))
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateLanguagesUser(languages_user_id, level) {
    this.setState({
      languageLevelOpen: false
    })
    $.ajax({
      url: `../ajaxUpdateLanguagesUser`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        level: level,
        id: languages_user_id
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.updateUserLanguages(JSON.parse(data.data.languages))
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateUserLanguages(languageArray) {
    this.setState({
      languages: languageArray,
      errorMessage: ''
    })
    this.checkLanguages()
  }

  deleteLanguagesUser(languages_user_id) {
    $.ajax({
      url: `../ajaxDeleteLanguagesUser`,
      dataType: 'JSON',
      type: 'DELETE',
      data: {
        id: languages_user_id
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.updateUserLanguages(JSON.parse(data.data.languages))
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  selectLevel(level) {
    const newLanguage = this.state.newLanguage
    const currentLanguages = this.state.languages.filter(function(language){
      return language.language_id == newLanguage.id
    })
    if(currentLanguages.length > 0) {
      //update current languages_user because language already exists
      this.updateLanguagesUser(currentLanguages[0].id, level)
    } else {
      //create new languages user
      this.createLanguagesUser(newLanguage.id, level)
    }
  }

  languageBackgroundColor(level) {
    switch (level) {
      case 5: return '#00569D'
      case 4: return  '#5E35B1'
      case 3: return  '#AA00FF'
      case 2: return  '#AB47BC'
      case 1: return '#EA80FC'
    }
  }

  languageLevelText(level) {
    switch (level) {
      case 5: return 'Native'
      case 4: return  'Advanced'
      case 3: return  'Intermediate'
      case 2: return  'Beginner'
      case 1: return 'Just Started'
    }
  }

  nativeLevelOptions() {
    return this.state.levels.filter(level => level === 5).map((level, i) => {
      return(
        <button
          className="levelPickerItem"
          onClick={() => this.selectLevel(level)}
          key={i}
          style={{
            border: `2px solid ${this.languageBackgroundColor(level)}`,
          }}>
          <h4 style={{color: this.languageBackgroundColor(level)}}>{this.languageLevelText(level)} {this.state.newLanguage.language}</h4>
        </button>
      )
    })
  }

  learningLevelOptions() {
    return this.state.levels.filter(level => level < 5).map((level, i) => {
      return(
        <button
          className="levelPickerItem"
          onClick={() => this.selectLevel(level)}
          key={i}
          style={{
            border: `2px solid ${this.languageBackgroundColor(level)}`,
          }}>
          <h4 style={{color: this.languageBackgroundColor(level)}}>{this.languageLevelText(level)} {this.state.newLanguage.language}</h4>
        </button>
      )
    })
  }

  languageLevelChoices() {
      return(
        <StandardModal onClose={() => this.closeLanguageChoices()}>
            <h5 style={{alignSelf: 'center', marginBottom: 12, marginTop: 12,  color: '#000000'}}>What is your speaking level of <span style={{fontWeight: 'bold'}}>{this.state.newLanguage.language}</span>?</h5>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <h5 style={{fontWeight: '600', color: '#9EA7AE', textAlign: 'left', marginLeft: 5, marginTop: 15}}>Fluent</h5>
              {this.nativeLevelOptions() }
              <h5 style={{fontWeight: '600', color: '#9EA7AE', textAlign: 'left', marginLeft: 5, marginTop: 15}}>Learning</h5>
              {this.learningLevelOptions() }
            </div>
        </StandardModal>
      )
  }

  errorMessage() {
    if(this.state.needsLearningLanguage) {
      this.setState({
        errorMessage: "Add a language you are learning."
      })
    } else if (this.state.needsNativeLanguage) {
      this.setState({
        errorMessage: "Add your native language."
      })
    } else {
      this.setState({
        errorMessage: ""
      })
    }
  }

  nextButton() {
    if(this.state.needsLearningLanguage || this.state.needsNativeLanguage) {
      return(
        <div style={{width: '100%', textAlign: 'center'}}>
          <BtnSecondary
            buttonText="Next Step - Profile Picture"
            fullWidth={true}
            onClick={() => this.errorMessage()}
            style={{marginTop: 24}}/>
        </div>
      )
    }
    return(
      <div style={{width: '100%', textAlign: 'center'}}>
        <BtnPrimary
          loading={false}
          buttonText="Continue: 📷"
          fullWidth={true}
          onClick={() => window.location.assign('/upload_picture')}
          style={{marginTop: 24}}/>
      </div>
    )
  }

  render() {
    return(
      <div style={{maxWidth: 450, margin: 'auto'}}>
        {this.state.openLanguageChoices && this.languageChoices()}
        {this.state.languageLevelOpen && this.languageLevelChoices()}
        <div>
          <div style={{width: '100%', padding: 15, marginTop: 50}}>
            <Search
              value={this.state.searchLanguageValue}
              placeholder="Search languages"
              onChange={(value) => this.setState({
                searchLanguageValue: value
              })}
            />
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {this.renderLanguageSuggestions()}
            </div>
            <p
              className="lightBlue"
              style={{textAlign: 'left', margin: 5, cursor: 'pointer'}}
              onClick={() => this.setState({openLanguageChoices: !this.state.openLanguageChoices})}>see all languages</p>
          </div>
        </div>
            <div style={{padding: 12, marginTop: 20, marginBottom: 20}}>
              <div style={{marginBottom: 20}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <FontAwesomeIcon
                    icon={faComment}
                    className={"darkBlue"}
                    style={{fontSize: 24, marginRight: 5}}
                  />
                  <h3 style={{fontSize: 18}}>My first or native language is</h3>
                </div>
                {this.renderNativeLanguages()}
                {this.state.needsNativeLanguage &&
                  <div className="alertContainer" onClick={() => this.setState({openLanguageChoices: !this.state.openLanguageChoices})}>
                    <h3 className="red" style={{ fontSize: 18, cursor: 'pointer'}}>Add your native language.</h3>
                  </div>}
              </div>
              <div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <FontAwesomeIcon
                    icon={faComments}
                    className={"darkBlue"}
                    style={{fontSize: 24, marginRight: 5}}
                  />
                  <h3 style={{fontSize: 18}}>I want to practice</h3>
                </div>
                {this.renderLearningLanguages()}
                {this.state.needsLearningLanguage &&
                  <div className="alertContainer" onClick={() => this.setState({openLanguageChoices: !this.state.openLanguageChoices})}>
                    <h3 className="red" style={{fontSize: 18, cursor: 'pointer'}}>Add a language you are learning.</h3>
                  </div>}
              </div>

            </div>
            <h4 className="red" style={{textAlign: 'center', marginBottom:10}}>{this.state.errorMessage}</h4>
            {this.props.nextButton && this.nextButton()}
      </div>
    )
  }
}

export default LanguageSettings;
